import { render, staticRenderFns } from "./certificates.vue?vue&type=template&id=41825094&scoped=true"
import script from "./certificates.vue?vue&type=script&lang=js"
export * from "./certificates.vue?vue&type=script&lang=js"
import style0 from "./certificates.vue?vue&type=style&index=0&id=41825094&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41825094",
  null
  
)

export default component.exports